import { xssHandlerProcess } from '@/utils/util';

const globalMixins = {
    data () {
        return {};
    },
    created () {},
    beforeDestroy () {},
    computed: {},
    methods: {
        xssHandlerProcess (value) {
            return xssHandlerProcess(value);
        }
    }
};

export default globalMixins;



// WEBPACK FOOTER //
// ./src/mixins/index.js